import React from "react";
import Table from "../../../components/Table/Table";
import { observer } from "mobx-react-lite";
import { inject } from "mobx-react";
import Modal from "../../../components/ui/Modal";
import { Button } from "../../../components/ui/Buttons";
import { withStyles } from "@material-ui/core";

const ModalServicosPlano = observer(
  ({
    openModalAutorizaAgendar,
    closeModal,
    disableModalButtons,
    handleClickAgendar,
    classes,
  }) => {

    return (
      <Modal isOpen={openModalAutorizaAgendar} className={classes.modal} maxWidth="630px" maxHeight="200px">
        <div>Verifique no sistema de benefícios (CNN) se o paciente está ativo no contrato e adimplente. Siga com o agendamento somente estiver ativo e adimplente.</div>
        <div>Deseja realizar o agendamento mesmo assim?</div>

        <div className={classes.footer}>
          <Button
            onClick={closeModal}
            kind="transparentHover"
            disabled={disableModalButtons}
            id="agd-msp-btn-nao"
          >
            Não
          </Button>
          <Button onClick={handleClickAgendar} disabled={disableModalButtons} id="agd-msp-btn-agd">
            Agendar
          </Button>
        </div>
      </Modal>
    );
  }
);

const styles = {
  modal: {
    padding: "16px",
    gap: "8px",
    display: "flex",
    flexDirection: "column",
    height: 340,
    justifyContent: "space-between",
  },
  footer: {
    display: "flex",
    justifyContent: "end",
    gap: "8px",
  },
};

const ModalServicosPlanoWithService = withStyles(styles)(ModalServicosPlano);
export default inject("atendimentoStore")(ModalServicosPlanoWithService);
